export const Assets = {
  svgs: {
    moon: require('../../assets/images/moon.svg'),
  },
};
